module.exports = __webpack_public_path__ + "img/fatture_anticipate_invoiceweb.24a06cef.png";